import { Formik, Form } from "formik";
import { Spinner } from "reactstrap";
import * as Yup from "yup";
import FormInput from "../../../components/FormInput";
import Header from "../../../layouts/AuthLayout/header/header";
import { changePassword } from "./change-password-page.service";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const validationSchema = Yup.object({
  currentPassword: Yup.string().required("Current Password is required"),
  password: Yup.string().required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), ""], "Passwords must match")
    .required("Confirm Password is required"),
});

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const handleSubmit = (values: any, actions: any) => {
    changePassword(values)
      .then((response) => {
        toast.success(response.data.message);
        navigate("/admin/dashboard");
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      })
      .finally(() => {
        actions.setSubmitting(false);
      });
    actions.setSubmitting(false);
  };
  return (
    <>
      <Header />
      <section className="ec-page-content ec-vendor-dashboard section-space-p">
        <div className="container">
          <div className="row">
            <div className="ec-shop-rightside col-lg-12 col-md-12">
              <div className="ec-vendor-dashboard-card space-bottom-30">
                <div className="ec-vendor-card-header">
                  <h5>Change password</h5>
                </div>
                <div className="ec-vendor-card-body">
                  <Formik
                    validationSchema={validationSchema}
                    initialValues={{
                      currentPassword: "",
                      password: "",
                      confirmPassword: "",
                    }}
                    onSubmit={handleSubmit}
                  >
                    {({
                      handleChange,
                      handleBlur,
                      errors,
                      values,
                      touched,
                      isSubmitting,
                    }) => (
                      <Form>
                        <FormInput
                          label="Current Password"
                          placeholder="Current Password"
                          name="currentPassword"
                          type="password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.currentPassword}
                          error={errors.currentPassword}
                          touched={touched.currentPassword}
                          autoFocus
                          isRequired={false}
                          className={""}
                        />
                        <FormInput
                          label="Password"
                          placeholder="Password"
                          name="password"
                          type="password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.password}
                          error={errors.password}
                          touched={touched.password}
                          isRequired={false}
                          className={""}
                        />
                        <FormInput
                          label="Confirm Password"
                          placeholder="Confirm Password"
                          name="confirmPassword"
                          type="password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.confirmPassword}
                          error={errors.confirmPassword}
                          touched={touched.confirmPassword}
                          isRequired={false}
                          className={""}
                        />

                        <div className="login_submit">
                          <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            ) : (
                              "Submit "
                            )}
                          </button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
